import IDMGlobals from './../IDMGlobals';

/**
 * Registration class used as the point of access for registration
 * operations on the identity fron-end and consumers.
 * @class
 */
export default class IDMRegistration {
  constructor(datasource) {
    this.datasource = datasource;
  }
  async register(enrollRole, forceRedirect, callbackURL, optContext, optionalOverrideAppID) {
    if ((this.datasource.opts.externalAuth || forceRedirect) && enrollRole) { //check if client want to authenticate externally
      await this.datasource.urlmanager.redirectRequest(this.datasource.opts.externalAuthDomain,
                                                       this.datasource.opts.externalRegistrationPath,
                                                       null, enrollRole, (window.location || callbackURL), optContext);
    } else {
      //request authentication
      const resp = await this.datasource.api.registration.register(enrollRole, optionalOverrideAppID);
      if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug("Registration resp: ", resp)
      //internall processing
      await this.datasource.handleImpersonateResponseAndReloadSession(resp);
      //return response for user
      return resp;
    }
  }
  async enroll(enrollObject) {
    //request authentication
    const resp = await this.datasource.api.registration.enroll(enrollObject);
    if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug("Enrollment resp: ", resp)
    //internall processing
    await this.datasource.handleImpersonateResponseAndReloadSession(resp);
    //return response for user
    return resp;
  }
  async confirmRegistrationAndLogin(regToken, regCode, email) {
    this.isAutheticating = true;
    //request federated login
    const resp = await this.datasource.api.registrationConfirmation.confirm(regToken, regCode, email);
    if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug("Validation resp: ", resp)
    //internall processing
      // #Improvement -- on registration confirmation, user is 100% not logged, so we don't need session handling at failure because
      //the confirmation haven't succeeded, so still not under authentication domain
    if (resp && resp.statusCode == 200) await this.datasource.handleAuthenticationResponse(resp, email, false);
    this.isAutheticating = false;
    //return response for user
    return resp;
  }
}
